import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import { v4 as uuidv4 } from "uuid";
import { toastSuccess, toastError, toastInfo } from "../../utils/alertHelper";

// Utility to get persistent deviceId (UUID stored in localStorage)
const getDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

// Utility to get device type from userAgent
const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  return "desktop";
};

// Utility to generate device token (session UUID)
const getDeviceToken = () => uuidv4();

function Otp() {
  const [otp, setOtp] = useState("");
  const [coords, setCoords] = useState({ latitude: null, longitude: null });
  const navigate = useNavigate();

  // Get location (coordinates) on mount
  useEffect(() => {
    if (!("geolocation" in navigator)) return;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        setCoords({ latitude: null, longitude: null });
      }
    );
  }, []);

  // Handle OTP verification, send device info + location to backend
  const handleVerify = async (e) => {
    e.preventDefault();
    const email = localStorage.getItem("email");
    const deviceId = getDeviceId();
    const devicetype = getDeviceType();
    const devicetoken = getDeviceToken();
    const { latitude, longitude } = coords;

    try {
      const response = await axios.post("/api/user/verifyOtp", {
        email,
        otp,
        latitude,
        longitude,
        deviceId,
        devicetype,
        devicetoken,
      });
      const { Status, UserToken, user, defaultCountry, defaultState, defaultCity } = response.data;

      if (Status === 1) {
        const role = user.roles?.[0]?.name || "";

        localStorage.setItem("email", user.email);
        localStorage.setItem("role", role);
        localStorage.setItem("token", UserToken);
        localStorage.setItem("defaultCountry", defaultCountry?._id || "");
        localStorage.setItem("defaultState", defaultState?._id || "");
        localStorage.setItem("defaultCity", defaultCity?._id || "");
        localStorage.setItem("auth", "true");

        toastSuccess("Login successful");
        navigate("/dashboard");
      } else {
        toastError("Wrong OTP");
      }
    } catch (error) {
      console.error(error);
      toastError("Something went wrong, please try again");
    }
  };

  return (
    <div className="">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-center min-vh-100">
              <div className="w-50 d-block bg-white shadow-lg rounded my-5">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="p-5">
                      <h1 className="h5 mb-1 text-center">Welcome Back!</h1>
                      <p className="text-muted mb-4">Enter your OTP to access admin panel.</p>
                      <form onSubmit={handleVerify}>
                        <div className="form-group mb-3">
                          <input
                            type="text"
                            placeholder="Enter OTP"
                            onChange={(e) => setOtp(e.target.value)}
                            className="form-control form-control-user"
                            id="exampleInputOtp"
                            required
                          />
                        </div>
                        <button type="submit" className="btn btn-success btn-block waves-effect waves-light">Verify OTP</button>
                      </form>
                      {coords.latitude && coords.longitude ? (
                        <div className="text-muted mt-3 text-center" style={{ fontSize: "0.9em" }}>
                          Device location detected
                        </div>
                      ) : (
                        <div className="text-warning mt-3 text-center" style={{ fontSize: "0.9em" }}>
                          Location not detected, please allow access for security.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Otp;